import { create } from "zustand";

interface Session {
  accessToken: string;
  expiresAt: string;
  /** Vazio: o refresh token vive em cookie httpOnly, fora do alcance do JS. */
  refreshToken?: string;
  tenantSlug?: string;
  /** "Manter conectado": sem limite de inatividade (só o prazo de 15 dias). */
  remember?: boolean;
}

interface AuthState {
  session: Session | null;
  /** true enquanto tenta restaurar a sessão pelo cookie ao abrir a página. */
  restoring: boolean;
  setSession: (session: Session | null) => void;
  setRestoring: (v: boolean) => void;
  clear: () => void;
}

/**
 * Sessão do cliente. Access token só em memória; o refresh fica em cookie
 * httpOnly (path /api/v1/auth), então recarregar a página não desloga.
 */
export const useAuth = create<AuthState>((set) => ({
  session: null,
  restoring: true,
  setSession: (session) => set({ session }),
  setRestoring: (restoring) => set({ restoring }),
  clear: () => set({ session: null }),
}));
